import React from 'react';
import PropTypes from 'prop-types';

import Introduction from './views/Introduction';
import Property from './views/Property';
import MarketAnalysis from './views/MarketAnalysis';
import ComparableSales from './views/ComparableSales';
import Estimation from './views/Estimation';
import NextSteps from './views/NextSteps';
import WhyHosman from './views/WhyHosman';

const EstimationFolderView = React.memo(({ sectionRefs, estimationFolder, comparableSales, similarSalesScreenshots, userHosmanian, printMode, yanportProperties, dvfTransactions, comparableSaleProperties }) => {
  const handleRef = (ref, index) => {
    if (!sectionRefs) return;

    sectionRefs.current[index] = ref
  }

  const allViews = [
    { id: 'introduction', view: Introduction },
    { id: 'votre-bien', view: Property },
    { id: 'analyse-du-marche', view: MarketAnalysis },
    { id: 'biens-comparables', view: ComparableSales },
    { id: 'votre-estimation', view: Estimation },
    { id: 'prochaines-etapes', view: NextSteps, printExclude: true },
    { id: 'pourquoi-hosman', view: WhyHosman, printExclude: true },
  ];
  const views = printMode ? allViews.filter(v => !v.printExclude) : allViews;
  return (
    <div className='flex flex-col' data-testid='EstimationFolderView'>
      {views.map((view, index) => (
        <div key={view.id} className='flex flex-col px-3'>
          <div id={view.id} ref={(ref) => handleRef(ref, index)}></div>
          <view.view
            estimationFolder={estimationFolder}
            comparableSales={comparableSales}
            similarSalesScreenshots={similarSalesScreenshots}
            userHosmanian={userHosmanian}
            printMode={printMode}
            yanportProperties={yanportProperties}
            dvfTransactions={dvfTransactions}
            comparableSaleProperties={comparableSaleProperties}
          />
        </div>
      ))}
    </div>
  );
})

export default EstimationFolderView;

EstimationFolderView.propTypes = {
  sectionRefs: PropTypes.object,
  estimationFolder: PropTypes.object.isRequired,
  comparableSales: PropTypes.array,
  similarSalesScreenshots: PropTypes.array,
  yanportProperties: PropTypes.array,
  dvfTransactions: PropTypes.array,
  comparableSaleProperties: PropTypes.array
};
